import React from "react";
import { mediaUrl } from "@/lib/api";

export const Avatar = ({ user, size = 40, className = "", onClick }) => {
  const src = mediaUrl(user?.avatar_url);
  const initial = (user?.name || "?").charAt(0).toUpperCase();
  return (
    <div
      onClick={onClick}
      style={{ width: size, height: size, fontSize: size * 0.42 }}
      className={`shrink-0 rounded-full overflow-hidden flex items-center justify-center font-bold text-white bg-gradient-to-br from-[#6C0BA9] to-[#C084FC] ${onClick ? "cursor-pointer" : ""} ${className}`}
    >
      {src ? (
        <img src={src} alt={user?.name} className="w-full h-full object-cover" />
      ) : (
        initial
      )}
    </div>
  );
};
